export const CONSENT_POLICY_VERSION = 1;
